import script from "./ArrowDown3Icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArrowDown3Icon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__